var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaya(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 210.324,
    height: 196.471,
    viewBox: "0 0 210.324 196.471",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #262626;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Playa",
    transform: "translate(3582.677 -496.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1284",
    "data-name": "Path 1284",
    className: "cls-1",
    d: "M204.485,109.47a3.508,3.508,0,0,0,1.942-4.557,56.342,56.342,0,0,0-8.792-14.748A28.012,28.012,0,0,0,214.49,80.146h41.264a13.629,13.629,0,0,0,14.022-14.021A13.292,13.292,0,0,0,259.058,52.5c-.922-7.5-5.258-17.923-17.327-17.923-11.859,0-16.255,10.064-17.278,17.527h-5.9a28,28,0,0,0-52.671,18.887A55.986,55.986,0,0,0,98.477,122.38H87.494v7.01H98.462a56.084,56.084,0,0,0,3.947,17.507,3.508,3.508,0,0,0,4.557,1.938l45.486-18.364,16.719,42.042a48.385,48.385,0,0,0-27.189,12.812H87.495v6.962h56.027a3.551,3.551,0,0,0,2.762-1.357c.4-.512,10.058-12.493,35.755-12.493a59.143,59.143,0,0,1,23.964,4.6l-1.681,4.263c-14.878,4.538-15.169,14.856-15.169,15.416l7.011.081c.02-.439.8-10.6,24.538-10.6s24.518,10.166,24.538,10.516h7.011a14.77,14.77,0,0,0-5.335-10.225h29.873V199.5H283.8v-7.011h14.021v-7.011H233.984l2.454-3.678a3.508,3.508,0,0,0-1.286-5.043l-6.2-3.268L242,148.674l6.2,3.268,3.263-6.2-18.607-9.815-3.268,6.2,6.2,3.263-13.068,24.815-6.2-3.263h0a3.534,3.534,0,0,0-4.89,1.832l-3.035,7.71a66.573,66.573,0,0,0-26.557-4.988c-1.984,0-3.856.088-5.676.21l-16.8-42.318H297.815v-7.011H172.494Zm12.241,65.521,11.715,6.169-2.8,4.206c-1.566-.1-3.194-.169-4.95-.169h0a69.176,69.176,0,0,0-8.179.486ZM133.5,83.473l16.354,40.5-22.012,8.885c-6.617-18.91-4.426-37.469,5.66-49.388Zm6.5-2.626c15.56,1.595,30,13.419,38.359,31.616l-22.009,8.869Zm87.706-21.74a3.508,3.508,0,0,0,3.508-3.508c0-.572.119-14.021,10.516-14.021,10.316,0,10.516,13.461,10.516,14.021a3.508,3.508,0,0,0,3.508,3.508,6.6,6.6,0,0,1,7.011,7.011,6.6,6.6,0,0,1-7.011,7.011h-10.6V66.118h-6.848v7.011H213.692a6.6,6.6,0,0,1-7.011-7.011,6.6,6.6,0,0,1,7.011-7.011Zm-56.087,3.508A20.987,20.987,0,0,1,210.971,52.4a13.322,13.322,0,0,0-11.3,13.721,13.067,13.067,0,0,0,6.965,12.206,21.063,21.063,0,0,1-13.977,5.322c-.5,0-.985-.048-1.479-.085a56.217,56.217,0,0,0-14.832-9.282c-.487-.207-.992-.351-1.484-.543h0a20.873,20.873,0,0,1-3.239-11.122Zm1.973,18.12h0a48.728,48.728,0,0,1,24.888,23.6l-13.629,5.5h0a62.433,62.433,0,0,0-32.12-32.951c.557,0,1.114-.081,1.676-.081h0A48.994,48.994,0,0,1,173.6,80.736Zm-64.355,25.981A48.836,48.836,0,0,1,121.55,89.5a62.317,62.317,0,0,0-.211,45.973l-13.629,5.5a48.722,48.722,0,0,1,1.535-34.265Z",
    transform: "translate(-3670.171 461.425)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1285",
    "data-name": "Path 1285",
    className: "cls-1",
    d: "M113.75,428.75h7.011v7.011H113.75Z",
    transform: "translate(-3685.908 225.164)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1286",
    "data-name": "Path 1286",
    className: "cls-1",
    d: "M201.25,446.25h7.011v7.011H201.25Z",
    transform: "translate(-3738.354 214.676)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1287",
    "data-name": "Path 1287",
    className: "cls-1",
    d: "M437.5,463.75h7.011v7.011H437.5Z",
    transform: "translate(-3879.958 204.186)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1288",
    "data-name": "Path 1288",
    className: "cls-1",
    d: "M498.75,490h7.011v7.011H498.75Z",
    transform: "translate(-3916.67 188.452)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1289",
    "data-name": "Path 1289",
    className: "cls-1",
    d: "M376.25,507.5h7.011v7.011H376.25Z",
    transform: "translate(-3843.246 177.963)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1290",
    "data-name": "Path 1290",
    className: "cls-1",
    d: "M140,490h7.011v7.011H140Z",
    transform: "translate(-3701.642 188.452)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1291",
    "data-name": "Path 1291",
    className: "cls-1",
    d: "M315,472.5h7.011v7.011H315Z",
    transform: "translate(-3806.534 198.942)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1292",
    "data-name": "Path 1292",
    className: "cls-1",
    d: "M297.5,420h7.011v7.011H297.5Z",
    transform: "translate(-3796.045 230.409)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1293",
    "data-name": "Path 1293",
    className: "cls-1",
    d: "M253.75,490h7.011v7.011H253.75Z",
    transform: "translate(-3769.822 188.452)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaya);
export default __webpack_public_path__ + "static/media/Playa.089836af1cbe388736e11ea3d65cce5e.svg";
export { ForwardRef as ReactComponent };